import { render, staticRenderFns } from "./RecalculateBoxInformation.vue?vue&type=template&id=3610abb9&"
import script from "./RecalculateBoxInformation.vue?vue&type=script&lang=js&"
export * from "./RecalculateBoxInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports